import { mixinFontFace } from '../styles/mixins';

const fontFace = () => `
  ${mixinFontFace({
  family: 'Musinsa Light',
  weight: 300,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsaot-Light',
  svg: 'MusinsaLight',
})}
  ${mixinFontFace({
  family: 'Musinsa',
  weight: 500,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsaot-Medium',
  svg: 'MusinsaRegular',
})}
  ${mixinFontFace({
  family: 'Musinsa',
  weight: 700,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsaot-Bold',
  svg: 'musinsaot-Bold',
})}
  ${mixinFontFace({
  family: 'Musinsa Stencil',
  weight: 300,
  style: 'normal',
  src: 'musinsaUI/fonts/MusinsaLightStencil',
  svg: 'MusinsaLightStencil',
})}
  ${mixinFontFace({
  family: 'Musinsa Stencil',
  weight: 500,
  style: 'normal',
  src: 'musinsaUI/fonts/MusinsaRegularStencil',
  svg: 'MusinsaRegularStencil',
})}
  ${mixinFontFace({
  family: 'Musinsa Italic',
  weight: 300,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsait-Light',
  svg: 'musinsait-Light',
})}
  ${mixinFontFace({
  family: 'Musinsa Italic',
  weight: 500,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsait-Medium',
  svg: 'musinsait-Medium',
})}
  ${mixinFontFace({
  family: 'Musinsa Italic',
  weight: 700,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsait-Bold',
  svg: 'musinsait-Bold',
})}
  ${mixinFontFace({
  family: 'Musinsa Round',
  weight: 500,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsard-Medium',
  svg: 'musinsard-Medium',
})}
  ${mixinFontFace({
  family: 'Musinsa Round',
  weight: 700,
  style: 'normal',
  src: 'musinsaUI/fonts/musinsard-Bold',
  svg: 'musinsard-Bold',
})}
`;

export default fontFace;